import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DestroyNotifierComponent } from 'src/app/core/component/destroy/destroy-notifier.component';
import { Status } from 'src/app/core/services/http/general/enums/status';
import { UserAdapterService } from 'src/app/core/services/http/user/adapters/user-adapter.service';
import { User } from 'src/app/core/services/http/user/interfaces/user';
import { UserService } from 'src/app/core/services/http/user/user.service';
import { ObservableWrapperService } from 'src/app/core/services/observable-wrapper/observable-wrapper.service';
import { clearFormControlsValues } from 'src/app/core/utils/utils';
import { AutoCompleteItem } from 'src/app/shared/auto-complete/interfaces/autocomplete-item';
import { RosterType } from '../../../../core/services/http/roster/enums/roster-types';
import { FormGroupService } from '../../../../shared/form-error/form-group.service';
@Component({
    selector: 'app-roster-adults-select',
    templateUrl: './roster-adults-select.component.html',
    styleUrls: ['./roster-adults-select.component.scss'],
    standalone: false
})
export class RosterAdultsSelectComponent extends DestroyNotifierComponent implements OnChanges, OnInit {
  @Input() form: UntypedFormGroup | undefined;

  @Output() itemChange = new EventEmitter<any>();
  @Output() selectChange = new EventEmitter<AutoCompleteItem[]>();

  removedItem: AutoCompleteItem | undefined;

  adults: AutoCompleteItem[] = [];
  selectedItemsDataFromFile: AutoCompleteItem[] = [];

  clearFormControlsValues = clearFormControlsValues;

  constructor(
    private userService: UserService,
    private userAdapterService: UserAdapterService,
    private observableWrapperService: ObservableWrapperService,
    private formGroupService: FormGroupService
  ) {
    super();
  }

  ngOnInit() {
    this.form?.get('type')?.valueChanges.subscribe((rosterType: number) => {
      if (rosterType === RosterType.Shared) {
        this.formGroupService.setRequiredValidatorToControl(this.form?.controls?.adults);
      } else {
        this.formGroupService.clearValidatorsAndValueFromControl(this.form?.controls?.adults);
      }
    });
  }

  ngOnChanges(): void {
    this.clearFormControlsValues(['items'], this.form);
  }

  onRemove(autoCompleteItem: AutoCompleteItem): void {
    this.removedItem = autoCompleteItem;
    this.itemChange.emit();
  }

  onSelectChange(items: AutoCompleteItem[]): void {
    this.sortTeachers(items);
    this.selectChange.emit(items);
    this.setFormControlValue(items);
  }

  onSearchChange(filter: string): void {
    this.observableWrapperService.unsubscribeWrapper<User[]>(
      this.userService.getEmployeesByRole(undefined, { filter, status: Status.Active }),
      this.destroyNotify,
      adults => {
        this.adults = this.userAdapterService.userToAutoCompleteItem(adults);
      }
    );
  }

  private setFormControlValue(items: AutoCompleteItem[]): void {
    this.form?.controls.adults.setValue(items);
  }

  private sortTeachers(items: AutoCompleteItem[]): void {
    // sort by last name (secondLabel) with fallback first name (firstLabel) if matching
    items.sort(
        (a, b) => {
          let sortValueA;
          let sortValueB;
          if (a.extraLabels.secondLabel === b.extraLabels.secondLabel) {
            sortValueA = a.extraLabels.firstLabel;
            sortValueB = b.extraLabels.firstLabel;
          } else {
            sortValueA = a.extraLabels.secondLabel ?? '';
            sortValueB = b.extraLabels.secondLabel ?? '';
          }

          return sortValueA.toLowerCase().localeCompare(
              sortValueB.toLowerCase(), 'en', { sensitivity: 'base' }
          );
        }
    );
  }
}
